export default "__VITE_ASSET__DJDCGqQ2__";